import React from 'react';

interface Cuts {
    id: number;
    dateCreation: string;
    grammar: number;
    reading: number;
    speaking: number;
    listening: number;
    writing: number;
}

interface BarChartItemProps {
    cuts: Cuts;
}

export const BarChartItem: React.FC<BarChartItemProps> = ({cuts}) => {

    const getBarClassName = (percentage: number): string => {
        if (percentage === 0) {
            return 'less-10 low';
        } else if (percentage <= 45) {
            return 'low';
        } else {
            return '';
        }
    };

    // Фильтруем элементы, у которых значение value не равно null
    const filteredItems = [
        {name: "Чтение", value: cuts.reading},
        {name: "Говорение", value: cuts.speaking},
        {name: "Аудирование", value: cuts.listening},
        {name: "Письмо", value: cuts.writing},
        {name: "Грамматика", value: cuts.grammar},
    ].filter(barItem => barItem.value !== null);

    return (
        <div className="bar-chart-item">
            <p className="h5">{cuts.dateCreation}</p>
            <div className="bar-chart">
                <div className="percents-box">
                    {Array.from({length: 11}, (_, index) => (
                        <span key={index}>{`${100 - index * 10}%`}</span>
                    ))}
                </div>
                <div className="bar-items-box">
                    <div className="bar-items">
                        {filteredItems.map((barItem, index) => (
                            <div className="bar-item" key={index}>
                                <div className={`bar-bg-box ${getBarClassName(barItem.value)}`}>
                                    <div className="bar-bg" style={{height: `${barItem.value}%`}}>
                                        <span className="bar-percents">{barItem.value}%</span>
                                    </div>
                                </div>
                                <p className="bar-name">{barItem.name}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};



